import { render, staticRenderFns } from "./TabelaCadastros.vue?vue&type=template&id=152c53c8&scoped=true"
import script from "./TabelaCadastros.vue?vue&type=script&lang=js"
export * from "./TabelaCadastros.vue?vue&type=script&lang=js"
import style0 from "./TabelaCadastros.vue?vue&type=style&index=0&id=152c53c8&prod&lang=css"
import style1 from "./TabelaCadastros.vue?vue&type=style&index=1&id=152c53c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c53c8",
  null
  
)

export default component.exports